import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/duihao-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-1de818f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page card" }
const _hoisted_2 = { class: "card-ed" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-type" }, "电子卡", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 交易完成 ")
], -1))
const _hoisted_5 = { class: "text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "京东卡", -1))
const _hoisted_8 = { class: "text1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "兑换时间", -1))
const _hoisted_10 = { class: "text1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "卡号", -1))
const _hoisted_12 = { class: "text1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "密码", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-text" }, "无更多数据", -1))

import { Toast } from 'vant'
import NoData from '@/components/NoData.vue'
import Divider from '@/components/Divider.vue'
import { queryAccountCardDetailFlow } from '@/apis/public'
import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const cardList = ref([])
const handleQueryAccountCardDetailFlow = async () => {
  const res = await queryAccountCardDetailFlow({})
  if (res.code === 0) {
    cardList.value = res.data
  } else {
    Toast(res.message)
  }
}
handleQueryAccountCardDetailFlow()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (cardList.value.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.cardNo
            }, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("span", null, _toDisplayString(item.value), 1),
                  _hoisted_7
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", null, "：" + _toDisplayString(item.grantTime), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", null, "：" + _toDisplayString(item.cardNo), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", null, "：" + _toDisplayString(item.cardPwd), 1)
                ])
              ])
            ]))
          }), 128)),
          _createVNode(Divider, null, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ], 64))
      : (_openBlock(), _createBlock(NoData, { key: 1 }))
  ]))
}
}

})